import script from "./DigitalShop.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalShop.vue?vue&type=script&setup=true&lang=js"

import "./DigitalShop.vue?vue&type=style&index=0&id=e2bc2b56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2bc2b56"]])

export default __exports__